import { render, staticRenderFns } from "./NewRecipient.vue?vue&type=template&id=b1f241fc"
import script from "./NewRecipient.vue?vue&type=script&lang=ts"
export * from "./NewRecipient.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../_locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Frecipients%2FNewRecipient.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports